module.exports = __webpack_public_path__ + "static/media/UsefullInformation.90589f53.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/UsefullInformation.pdf
// module id = 585
// module chunks = 0